module.exports = __webpack_public_path__ + "static/media/fm.20d3e527.svg";